/* Shorae — méga-menu : bascule des panneaux depuis la colonne latérale.
   L'ouverture et la fermeture du méga-menu restent gérées par le thème. */

(function () {
  'use strict';

  var CAN_HOVER = window.matchMedia('(hover: hover)').matches;

  function select(root, index) {
    root.querySelectorAll('[data-shorae-tab]').forEach(function (tab) {
      tab.setAttribute('aria-selected', tab.dataset.shoraeTab === index ? 'true' : 'false');
    });
    root.querySelectorAll('[data-shorae-panel]').forEach(function (panel) {
      if (panel.dataset.shoraePanel === index) {
        panel.setAttribute('data-active', '');
      } else {
        panel.removeAttribute('data-active');
      }
    });
  }

  function setup(root) {
    if (root.dataset.shoraeReady === 'true') return;
    root.dataset.shoraeReady = 'true';

    var tabs = root.querySelectorAll('[data-shorae-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab, i) {
      var index = tab.dataset.shoraeTab;

      if (CAN_HOVER) {
        tab.addEventListener('mouseenter', function () { select(root, index); });
      }
      tab.addEventListener('focus', function () { select(root, index); });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowDown') next = tabs[i + 1] || tabs[0];
        if (event.key === 'ArrowUp') next = tabs[i - 1] || tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        next.focus();
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-shorae-mm]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Réinitialisation dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) { init(event.target); });
})();
